import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApiModule } from './api';
import { CookieService } from './cookie';
import { ErrorModule } from './error';
import { IconModule } from './icon';
import { IdleModule } from './idle';
import { IntegrationModule } from './integration/integration.module';
import { L10nModule } from './l10n';
import { LayoutModule } from './layout';
import { RoutingModule } from './routing';
import { ConfigModule } from './config/config.module';

const BROWSER_MODULES = [BrowserModule, BrowserAnimationsModule];
const HTTP_CLIENT_MODULES = [HttpClientModule, HttpClientXsrfModule];
const CORE_MODULES = [ApiModule, ConfigModule, L10nModule, IdleModule, IconModule, ErrorModule, LayoutModule, RoutingModule, IntegrationModule];
const CORE_SERVICES = [CookieService];
@NgModule({
  imports: [BROWSER_MODULES, HTTP_CLIENT_MODULES, CORE_MODULES],
  exports: [CORE_MODULES],
  providers: [CORE_SERVICES]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded, import it only once.');
    }
  }
}
